import axiosInstance from 'Services/APIService';

export interface ContactFormPayload {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
}

export interface SubmitContactResponse {
  message: string;
}

export interface ContactSubmission {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  subject: string;
  message: string;
  submittedAt: string;
  status: string;
}

export interface ContactSubmissionsResponse {
  count: number;
  submissions: ContactSubmission[];
}

export type ContactSubmissionStatus = 'new' | 'reviewed' | 'resolved' | 'archived';

export interface UpdateContactSubmissionPayload {
  status: ContactSubmissionStatus;
  notes?: string;
}

export const submitContactForm = async (
  payload: ContactFormPayload
): Promise<SubmitContactResponse> => {
  const { data } = await axiosInstance.post<SubmitContactResponse>(
    '/ContactUs/Submit',
    payload,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );

  return data;
};

export const getContactSubmissions = async (
  status?: string
): Promise<ContactSubmissionsResponse> => {
  const params = status && status !== 'all' ? { status } : undefined;

  const { data } = await axiosInstance.get<ContactSubmissionsResponse>(
    '/ContactUs/Submissions',
    { params }
  );

  return data;
};

export const updateContactSubmissionStatus = async (
  id: string,
  payload: UpdateContactSubmissionPayload
): Promise<{ message?: string; submission?: ContactSubmission }> => {
  const encodedId = encodeURIComponent(id);

  const { data } = await axiosInstance.patch<{ message?: string; submission?: ContactSubmission }>(
    `/ContactUs/Submissions/${encodedId}`,
    payload,
    {
      headers: { 'Content-Type': 'application/json' }
    }
  );

  return data;
};
